export default __webpack_public_path__ + "static/media/aboutus.eac964dc.png";